import SessionProgressDescription from './SessionProgressDescription'

export default SessionProgressDescription
